import inViewport from '../modules/is-in-viewport.js';
import navbar from '../modules/navbar.js';
import megamenu from '../modules/megamenu.js';
import sliders from '../modules/sliders.js';
import video from '../modules/video.js';
import localScroll from '../modules/local-scroll.js';
import postFilters from '../modules/post-filters.js';
import formButtons from '../modules/form-buttons.js';
import matchHeight from '../modules/matchHeight.js';
import hero from '../blocks/hero.js';
import productSlider from '../blocks/product-slider.js';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    inViewport.init();
    navbar.init();
    megamenu.init();
    sliders.init();
    video.init();
    localScroll.init();
    postFilters.init();
    hero.init();
    productSlider.init();
    formButtons.init();
    matchHeight.init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js